import {
  Hero,
  PageProps,
  getLinks,
  getStoryBySlug,
  useStoryblokState,
} from '@cinch-nx/data-storyblok'
import {
  SEOPageFeature,
  SEOPageStoryContent,
  storyblokLinkToPath,
} from '@cinch-nx/landing-feature-seo-pages'
import Head from '@cinch-nx/landing-ui-shared/lib/head/head'
import type { GetStaticPaths, GetStaticProps } from 'next'

function SEOPage({ story, preview }: PageProps<SEOPageStoryContent>) {
  const { content, slug } = useStoryblokState({ story, enableBridge: preview })
  const SEO = content?.SEO?.[0]
  return (
    <>
      <Head
        {...SEO}
        fallbackTitle={slug}
        fallbackDescription={'Cinch Used Cars'}
      />
      {content && <SEOPageFeature content={content} />}
    </>
  )
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export const getStaticProps: GetStaticProps = async ({
  params,
  preview = false,
}) => {
  try {
    const slug = params?.slug as string
    const story = await getStoryBySlug<SEOPageStoryContent>(
      `seo-pages/electric-cars/${slug}`,
      {
        version: preview ? 'draft' : 'published',
        cv: Date.now(),
      },
    )

    if (!story) {
      return { notFound: true } as const
    }

    const HeroProps: Hero = story.content?.hero[0]

    return {
      props: {
        story,
        preview,
        layoutProps: {
          heroProps: HeroProps,
          showBorderRadius: true,
          showFooterBorderRadius: false,
        },
      },
      revalidate: 60, // In seconds
    }
  } catch (error) {
    console.log(error)
    return { notFound: true } as const
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  // Get the paths we want to pre-render based on data
  try {
    const links = await getLinks('seo-pages/electric-cars')
    const paths = storyblokLinkToPath({ links })

    return { paths, fallback: 'blocking' }
  } catch {
    return { paths: [], fallback: 'blocking' }
  }
}

export default SEOPage
